/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Period_Group_By_InvalidInputs */

const vi_error_period_group_by_invalid = /** @type {(inputs: Error_Period_Group_By_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cách xem theo kỳ không hợp lệ. Hãy chọn Tuần, Tháng hoặc Năm.`)
};

/**

* @param {Error_Period_Group_By_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_period_group_by_invalid = /** @type {((inputs?: Error_Period_Group_By_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Period_Group_By_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_period_group_by_invalid(inputs)
});